import { render, staticRenderFns } from "./ShareBookingLink.vue?vue&type=template&id=01dbf5ee&scoped=true"
import script from "./ShareBookingLink.vue?vue&type=script&lang=js"
export * from "./ShareBookingLink.vue?vue&type=script&lang=js"
import style0 from "./ShareBookingLink.vue?vue&type=style&index=0&id=01dbf5ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dbf5ee",
  null
  
)

export default component.exports